import { generateSearchParams } from '@/utils/generateSearchParams';
import { request } from '@/utils/request';
import { ResponseBasis, ResponseWithSeo } from '@/api/api.types';
import { ArticleItem, ArticlesListOptions } from '@/api/articles/articles.types';

export async function getArticlesList(options: ArticlesListOptions) {
  const searchParams = generateSearchParams(options);
  return request<ResponseBasis<ArticleItem>>(`/articles/?${searchParams.toString()}`);
}

export async function getCurrentArticle({ id }: { id: number }) {
  return request<ArticleItem & ResponseWithSeo>(`/articles/${id}/`);
}

export async function getCurrentArticleBySlug({ slug }: { slug: string }) {
  return request<ArticleItem & ResponseWithSeo>(`/articles/slug/${slug}/`);
}